import jsSHA from "jssha";

class ImageUrlSigner {
  constructor({ salt, secret, url }) {
    this.salt = salt;
    this.secret = secret;
    this.url = url;
    this.canSign = salt && secret
  }

  _urlSafeBase64 = (string) => {
    /* NOTE: btoa cannot handle multibyte characters correctly,
       however we are optimistic here that we will not need that (we
       encode urls and url-paths only). Luckily btoa will throw an
       error when it encounters an unencodable char so we will know
       when we need this.

       See: https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
     */
    let b64str = btoa(string);
    return b64str.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
  };

  // NOTE: why is this function not a browser built-in?
  _hexDecode = (hex) => {
    let string = "";

    // Each character in the original string is made of two
    // hex values. So we iterate through pairs of chars here.
    for (let index = 0; index < hex.length; index += 2) {
      let hexPair = hex.slice(index, index + 2); // e.g. '0d' or 'de' or '42'

      // Obtain char code by interpreting the string as a hex number
      let charCode = parseInt(hexPair, 16);

      // Convert char code to string representation and append to output string
      string += String.fromCharCode(charCode);
    }

    return string;
  };

  _sign = (target) => {
    const shaObj = new jsSHA("SHA-256", "TEXT", {
      hmacKey: {
        value: this.secret,
        format: "HEX",
      },
    });
    shaObj.update(this._hexDecode(this.salt));
    shaObj.update(target);
    return this._urlSafeBase64(shaObj.getHash("BYTES"));
  };

  /**
  "resizingType": 'fill',
  "width": 100,
  "height": 100,
  "gravity": 'sm',
  "enlarge": 1,
  "extension": 'webp'
  **/
  create = (originalImageUrl, config) => {
    let encodedUrl = this._urlSafeBase64(originalImageUrl);
    let path = `/rs:${config.resizingType}:${config.width}:${config.height}:${config.enlarge}/g:${config.gravity}/${encodedUrl}.${config.extension}`;
    let signature
    if (this.canSign) {
      signature = this._sign(path);
    } else {
      console.warn("Cannot sign url, using 'insecure' paths")
      signature = "insecure"
    }
    let result = `${this.url}/${signature}${path}`;
    return result;
  };
}

export default ImageUrlSigner;
